import React from "react";
import ReactDOM from "react-dom/client";
import { useSelector } from "react-redux";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import store from "../../Redux Store/store";

function AdvisorConditionsModal({ resolve, navigate }) {
  const loggedInUser = store.getState()?.auth;

  function getTitle() {
    if (loggedInUser?.isSkipLogin || !loggedInUser?.isAuthenticated) {
      return (
        <p className="text-[1.125rem] font-[600] text-[#F44336]">Onboarding Incomplete!</p>
      );
    }
    else if(loggedInUser?.user?.advisor_onboarding_status_id?.title === "Pending" || loggedInUser?.user?.advisor_onboarding_status_id?.title === "Re-Submitted"){
      return (
        <p className="text-[1.125rem] font-[600] text-[#F44336]">Verification Pending!</p>
      );
    }
    else if(loggedInUser?.user?.advisor_onboarding_status_id?.title === "Rejected"){
      return (
        <p className="text-[1.125rem] font-[600] text-[#F44336]">Rejection Remark!</p>
      );
    }
  }
  
  function getSubTitle() {
    if (loggedInUser?.isSkipLogin || !loggedInUser?.isAuthenticated) {
      return (
        <p className="text-[0.875rem] font-[500] text-[#52575C]"><p className="text-[0.875rem] font-[500] text-[#52575C]">We need to verify your details before granting access.</p></p>
      );
    }
    else if(loggedInUser?.user?.advisor_onboarding_status_id?.title === "Pending"){
      return (
        <p className="text-[0.875rem] font-[500] text-[#52575C]">We need to verify your details before granting access.</p>
      );
    }
    else if(loggedInUser?.user?.advisor_onboarding_status_id?.title === "Rejected"){
      return (
        <p className="text-[0.875rem] font-[500] text-[#52575C]">{loggedInUser?.user?.rejection_remark[loggedInUser?.user?.rejection_remark?.length - 1]?.reason}</p>
      );
    }
  }
  

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="flex flex-col bg-white p-6 rounded-lg shadow-md w-80 gap-6">
        <div className="flex flex-col gap-2">
          <div className="flex flex-row justify-between">
            {getTitle()}
          </div>
          {getSubTitle()}
        </div>

        <div className="flex flex-row justify-end gap-4">
          <CustomButton label="Close" variant="outlined" onClick={() => {resolve(false)}}/>
          {loggedInUser?.user?.advisor_onboarding_status_id?.title === "Rejected" &&
            <CustomButton
              label='Re-Submit'
              onClick={() => {
                if (navigate) {
                  navigate('/advisor-onboarding');
                  resolve(false);
                }
              }}
            />
          }
          {loggedInUser?.isSkipLogin &&
            <CustomButton
              label='Complete Profile'
              onClick={() => {
                if (navigate) {
                  navigate('/advisor-onboarding');
                  resolve(false);
                }
              }}
            />
          }
        </div>
      </div>
    </div>
  );
}

// Static method to show modal
AdvisorConditionsModal.show = (navigate) => {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = ReactDOM.createRoot(container);

    const cleanup = () => {
      setTimeout(() => {
        root.unmount();
        container.remove();
      }, 0);
    };

    const wrappedResolve = (value) => {
      resolve(value);
      cleanup();
    };

    root.render(<AdvisorConditionsModal resolve={wrappedResolve} navigate={navigate} />);
  });
};

export default AdvisorConditionsModal;
